import {Component, OnInit, Input} from '@angular/core';
import {NaviosViagensService} from "./navios-viagens.service";
import {NaviosViagensModel} from "./navios-viagens.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";

declare var swal: any;

@Component({
  selector: 'app-navios-viagens-table',
  templateUrl: './navios-viagens-table.component.html'
})
export class NaviosViagensTableComponent extends Components implements OnInit {

  @Input()
  id_navio: string = '';

  viagens: NaviosViagensModel[] = [];

  constructor(
    private naviosViagensService: NaviosViagensService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes
  ) {
    super();
  }

  ngOnInit() {
    this.carregandoTabela = true;

    this.naviosViagensService.getPaginacao(1,this.itensPorPagina, ['navio', 'porto_descarga', 'porto_carregamento'], {"id_navio":this.id_navio})
      .subscribe(data => {
        this.viagens = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.viagens);
        }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

  delete(viagem) {
    let viagens = this.viagens;
    let naviosViagensService = this.naviosViagensService;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarNavio')+viagem.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if (this.global.debug) {
          console.log(viagens);
        }
        let index = viagens.indexOf(viagem);
        viagens.splice(index, 1);

        naviosViagensService.apagar(viagem.id)
          .subscribe(res => {
              this.navios = viagens;
            },
            err => {
              // Revert the view back to its original state
              viagens.splice(index, 0, viagem);
              this.viagens = viagens;

              this.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.naviosViagensService.getPaginacao(pagina,this.itensPorPagina)
      .subscribe(data => {
        this.viagens = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
          this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/navios-viagens/navios-viagens-table.component.ts